<div class="padding">
  <p>
    {{ 'i18n.menuProfitPro.unitOfMeasure.tldr1' | translate }}
  </p>
  <p>
    {{ 'i18n.menuProfitPro.unitOfMeasure.tldr2' | translate }}
  </p>
</div>
